import { render, staticRenderFns } from "./EditIndexes.vue?vue&type=template&id=867624a8&scoped=true&"
import script from "./EditIndexes.vue?vue&type=script&lang=ts&"
export * from "./EditIndexes.vue?vue&type=script&lang=ts&"
import style0 from "./EditIndexes.vue?vue&type=style&index=0&id=867624a8&lang=stylus&scoped=true&"
import style1 from "./EditIndexes.vue?vue&type=style&index=1&id=867624a8&scoped=true&lang=css&"
import style2 from "./EditIndexes.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867624a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCheckbox,VIcon,VSelect,VSimpleTable,VSpacer})
